// Getting dom elements and running functions
const zoomContainer = document.querySelector('[data-zoom-container]');
const zoomImagesContainer = document.querySelector('[data-zoom-images-container]');
const zoomImagesWrapper = document.querySelector('[data-zoom-images-wrapper]');
const zoomPaginationContainer = document.querySelector('[data-zoom-pagination-container]');
const zoomCloseButton = document.querySelector('[data-zoom-close-button]');
const zoomPaginationBullets = [...document.querySelectorAll('[data-zoom-pagination-bullet]')]
const raffleImages = document.querySelectorAll('#raffle__collage-grid .collage__image');
const lookbookImages = document.querySelectorAll('#lookbook__collage-grid .collage__image');
const productImages = document.querySelectorAll('[data-product-image]'); // Only get the images of the product media for the zoom (videos in zoom is not in scope)

// Defining functions to use
let allPaginations = [...zoomPaginationBullets]

const initZoomImagesPagination = (bullets) => {
  bullets.forEach(bullet => {
    bullet.addEventListener('click', () => {
      const targetIndex = bullet.dataset.index;
      scrollZoom(targetIndex);
    })
  })
}

const initZoom = (images, imagesSrcArray) => {
  images.forEach((image, index) => {
    // If the images are from product.media, they don't have a data-zoom-id yet to get the targetIndex
    const targetIndex = index + 1;
    image.dataset.zoomId = targetIndex;
    const img = image.tagName === "IMG" ? image : image.querySelector('img'); // Images from raffles are under pictures, so the actual img we want is nested inside
    
    const handleZoomImageClick = node => {
      node && node.classList.remove('loading');
      openZoomContainer();
      scrollZoom(targetIndex, 'auto');
    }
    
    img.addEventListener('click', () => {
      handleZoomImagesInit(imagesSrcArray);
      const zoomImagesNodeList = document.querySelectorAll('.zoom__image');
      const zoomImages = Array.from(zoomImagesNodeList);
      const parentNode = img.parentNode

      if (zoomImages.every(img => img.complete)) {
        handleZoomImageClick();
      } else {
        let loadedCount = 0;
        parentNode.classList.add('loading')

        const handleFirstScroll = () => {
          loadedCount ++;
          if (loadedCount === imagesSrcArray.length) {
            handleZoomImageClick(parentNode);
          }
        }

        zoomImagesNodeList.forEach(image => {
          image.addEventListener('load', handleFirstScroll);
        })
      }
      
    })
  })
  
  zoomCloseButton && zoomCloseButton.addEventListener('click', () => {
    closeZoomContainer(zoomContainer);
  });
}

const scrollZoom = (targetIndex, mode = 'smooth') => {
  const target = document.querySelector(`.zoom__image[data-zoom-id='${targetIndex}']`);
  const targetLeft = target.offsetLeft;
  zoomImagesContainer.scrollTo({
    left: targetLeft,
    behavior: mode
  })
}

const openZoomContainer = () => {
  // document.body.style.overflow = "hidden"; // Prevent body scrolling
  lockBody(zoomContainer)
  zoomContainer.classList.add('active');
  document.addEventListener("keyup", handleEscKey);
  document.addEventListener('keyup', handleArrowNavigation)
}

const closeZoomContainer = () => {
  // document.body.style.overflowY = ""; // Re-enable body scrolling
  unlockBody(zoomContainer)
  zoomContainer.classList.remove('active');
  document.removeEventListener("keyup", handleEscKey);
  document.removeEventListener('keyup', handleArrowNavigation)
}

const handleEscKey = e => e.key === "Escape" && closeZoomContainer();

const togglePaginationActive = (targetIndex) => {
  zoomPaginationBullets.forEach(bullet => {
    bullet.classList[bullet.dataset.index == targetIndex ? 'add' : 'remove']('active')
  })
}

const handleScroll = () => {
  const wrapperLeft = -zoomImagesWrapper.getBoundingClientRect().left;
  const targetIndex = Math.abs(Math.round(wrapperLeft / window.innerWidth)); // Sometimes we get -0 index, change it to 0 with Math.abs
  togglePaginationActive(targetIndex + 1);
}

const handleArrowNavigation = e => {
  e.key === "ArrowRight" ? handleNextClick() 
  : e.key === "ArrowLeft" ? handlePrevClick() 
  : null
}

const handleNextClick = () => {
  // get current index by checking active pagination's data-zoom-id
  const currentZoomId = document.querySelector('[data-zoom-pagination-bullet].active').dataset.index;
  const currentIndex = parseInt(currentZoomId)
  // get last index
  const lastZoomId = allPaginations[allPaginations.length - 1].dataset.index
  const lastIndex = parseInt(lastZoomId)
  // unless already at last index, scroll right (currentIndex + 1)
  currentIndex !== lastIndex && scrollZoom(currentIndex + 1)
}
const handlePrevClick = () => {
  // get current index by checking active pagination's data-zoom-id
  const currentZoomId = document.querySelector('[data-zoom-pagination-bullet].active').dataset.index;
  const currentIndex = parseInt(currentZoomId)

  // unless already at first index, scroll left (currentIndex - 1)
  currentIndex !== 1 && scrollZoom(currentIndex - 1)
}

const handleZoomImagesInit = imagesSrcArray => {
  if (zoomImagesWrapper.children.length === 0) {
    imagesSrcArray.forEach((src, index) => {
      // Create zoom images and append into container
      const zoomImage = document.createElement('IMG');
      zoomImage.src = src;
      zoomImage.setAttribute("loading", "eager");
      zoomImage.className = 'zoom__image shrink-0 w-screen snap-start object-contain pointer-events-none'
      zoomImage.dataset.zoomId = index + 1;
      zoomImagesWrapper.appendChild(zoomImage);
    })
    
    // Bind event listeners to arrow navigation
    const leftArrow = document.querySelector('[data-zoom-navigation-back]')
    const rightArrow = document.querySelector('[data-zoom-navigation-next]')
    leftArrow.addEventListener('click', handlePrevClick)
    rightArrow.addEventListener('click', handleNextClick)

    zoomImagesContainer.addEventListener("scroll", () => {
      handleScroll();
    }, {passive: true});
  }
}

if (raffleImages.length > 0) {
  const raffleImagesArray = Array.from(raffleImages);
  const raffleImagesSrcArray = raffleImagesArray.map(image => image.querySelector('img').src.replace('_30x.', '.'));
  initZoom(raffleImages, raffleImagesSrcArray);
}

if (lookbookImages.length > 0) {
  const lookbookImagesArray = Array.from(lookbookImages);
  const lookbookImagesSrcArray = lookbookImagesArray.map(image => image.querySelector('img').src.replace('_30x.', '.'));
  initZoom(lookbookImages, lookbookImagesSrcArray);
}

if (productImages.length > 0) {
  const productImagesJson = zoomContainer.querySelector('script').innerHTML;
  const productImagesArray = Array.from(JSON.parse(productImagesJson));
  const productImagesSrcArray = productImagesArray.map(src => src.replace('//cdn', 'https://cdn'));
  initZoom(productImages, productImagesSrcArray);
  initZoomImagesPagination(zoomPaginationBullets)
}